export const formatTheDate = (dateObject: any | undefined | null) => {
  if (!dateObject) {
    return "";
  }

  return `${dateObject.getDate()}.${
    dateObject.getMonth() + 1
  }.${dateObject.getFullYear()}`;
};
